/** The sidebar's own state, per browser: collapsed to a rail, and which sections / folders are folded. Pure. */

export interface SidebarPrefs {
  collapsed: boolean
  /** Section keys ("queues", "boards", …) and folder ids that are folded shut. */
  folded: string[]
}

export const SIDEBAR_PREFS_KEY = 'ss.nav.sidebar'
export const DEFAULT_SIDEBAR_PREFS: SidebarPrefs = { collapsed: false, folded: [] }

/** Whatever localStorage holds → valid prefs; anything unreadable is the default. */
export function parseSidebarPrefs(raw: string | null): SidebarPrefs {
  if (!raw) return DEFAULT_SIDEBAR_PREFS
  try {
    const v = JSON.parse(raw) as Partial<SidebarPrefs>
    return {
      collapsed: v.collapsed === true,
      folded: Array.isArray(v.folded) ? [...new Set(v.folded.filter((x): x is string => typeof x === 'string'))].slice(0, 200) : [],
    }
  } catch {
    return DEFAULT_SIDEBAR_PREFS
  }
}

export function toggleFolded(prefs: SidebarPrefs, key: string): SidebarPrefs {
  return {
    ...prefs,
    folded: prefs.folded.includes(key) ? prefs.folded.filter((k) => k !== key) : [...prefs.folded, key],
  }
}

/** `[` toggles the rail, as in Linear and Jira, unless the user is typing. */
export function isToggleShortcut(e: { key: string; metaKey: boolean; ctrlKey: boolean; altKey: boolean; target: unknown }): boolean {
  if (e.key !== '[' || e.metaKey || e.ctrlKey || e.altKey) return false
  const el = e.target as { tagName?: string; isContentEditable?: boolean } | null
  const tag = el?.tagName?.toUpperCase()
  return !(el?.isContentEditable || tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT')
}
